module.exports = __webpack_public_path__ + "img/good.bba63d9c.png";